export namespace SettingsAction {
  export class GetAppInfo {
    static readonly type = '[SettingsAction] GetAppInfo';
    constructor() {}
  }
}
